import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[luiPreventBubble]',
  standalone: true,
})
export class PreventBubbleDirective {
  @HostListener('click', ['$event']) onClick(e: MouseEvent) {
    e.stopPropagation();
  }
}
